import axios from "@/plugins/axios";

let url = (data = {}) => "/api/v1/recruitments/${_recruitment}/application".interpolate(data);

export default {
    get(data) {
        return axios.get(`${url(data)}`).then((result) => result.data);
    },
    post(data) {
        return axios.post(url(data), data).then((result) => result.data);
    },
    put(data) {
        return axios.put(url(data), data).then((result) => result.data);
    },
    putApply(data) {
        return axios.put(`${url(data)}/apply`, data).then((result) => result.data);
    },
};
